/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * An enumeration of the different types of partnerships
 */
export enum EnumPartnershipType {
    /**
     * An internal partnership represents the internal employees of the partnership owner's employees.
     */
    Internal = 0,
    /**
     * A portal partnership grants employees of a different company access to the data of the partnership owner,
     * so they can request orders.
     */
    Portal = 1,
}
